// App library
import Svg from "./modules/svg";
import NewsletterV2 from "./modules/newsletterV2";

import Modal from "./modules/modal";
import VideoEmbedInline from "../components/shared/video-embed";
import { trackEvent } from "../common/analytics";
import { resolveStringToWindowObject } from "./modules/utility";
import imkt from '../imkt';

const SetGlobalDependencies = (imkt) => {

  imkt.core.is = {};
  imkt.core.is.mobile = () => false;

  imkt.utils.tracking.trackEvent = trackEvent;

  imkt.ui.Modal = Modal;
  imkt.components.VideoEmbedInline = VideoEmbedInline;
};

const EnableComponentJS = () => {
  const listOfComponents = document.querySelectorAll(
    'script[type="text/x-component"]'
  );
  listOfComponents.forEach((elem) => {
    const componentInfo = JSON.parse(elem.innerHTML.trim()),
      componentRoot = elem.parentNode;
    const { type, params } = componentInfo;
    const componentInfoType = resolveStringToWindowObject(type);

    try {
      return new componentInfoType(componentRoot, { ...params });
    } catch (e) {
      console.log(e);
    }
  });
};

var Gitguide = function () {
  SetGlobalDependencies(imkt);

  document.querySelector(".hamburger").addEventListener("click", function () {
    Array.from(document.querySelectorAll(".hamburger, .primary-nav")).forEach(
      function (item) {
        item.classList.toggle("is-active");
      }
    );
  });

  var currentPath = window.location.pathname;

  var currentAndParentLinks = document.querySelectorAll(
    '[href*="' + currentPath + '"]'
  );
  Array.from(currentAndParentLinks).forEach(function (navLink) {
    if (navLink.getAttribute("href") == currentPath) {
      navLink.classList.add("active-current-page-link");
    } else if (currentPath.indexOf(navLink.getAttribute("href")) == 0) {
      navLink.classList.add("active-parent-page-link");
    }
  });

  var activePageLinks = document.querySelectorAll(
    ".tutorial-sidebar .active-current-page-link, .tutorial-sidebar .active-parent-page-link"
  );

  for (var a = 0; a < activePageLinks.length; a++) {
    activePageLinks[a].classList.add("active");
    activePageLinks[a].setAttribute('aria-hidden', false);
    if (activePageLinks[a].nextElementSibling) {
      activePageLinks[a].nextElementSibling.classList.add("is-active");
      activePageLinks[a].nextElementSibling.setAttribute('aria-hidden', false);
    }
    var parentGroup = activePageLinks[a].closest("._group");
    var parentWrap = activePageLinks[a].closest("._group-wrap");
    var parentTOC = activePageLinks[a].closest("._toc");
    var ells = [];
    ells = ells.concat(
      Array.from(parentGroup.children),
      parentWrap ? Array.from(parentWrap.children) : [],
      parentTOC ? Array.from(parentTOC.children) : []
    );
    for (var i = 0; i < ells.length; i++) {
      ells[i].classList.add("is-active");
      ells[i].setAttribute('aria-hidden', false);
    }
  }

  // Initialize browser interactions
  new Svg();

  new NewsletterV2();

  EnableComponentJS();
};

(function () {
  if (!document.body.classList.contains("edit")) {
    // Load app
    Gitguide();

    import("../common/code-blocks").then(({ default: initialize }) => initialize());
  }
})();